// Script without triggering cart notification
function initializeQuickATCVariantSelected() {
  document.addEventListener("DOMContentLoaded", function() {

    const addButtons = document.querySelectorAll(".c-quick-atc-button-add");
    const removeButtons = document.querySelectorAll(".c-quick-atc-button-remove");

    addButtons.forEach(button => {
      button.addEventListener("click", function() {
        const variantId = this.getAttribute("data-variant-id");
        const mainProductTitle = this.getAttribute("data-main-product-title");
        addVariantSelectedToCart(variantId, 1, this, mainProductTitle);
      });
    });

    removeButtons.forEach(button => {
      button.addEventListener("click", function() {
        const variantId = this.getAttribute("data-variant-id");
        removeVariantSelectedFromCart(variantId, this);
      });
    });
  });

  function addVariantSelectedToCart(variantId, quantity, buttonElement, mainProductTitle) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [{ 
          id: variantId, 
          quantity: quantity,
          properties: {
            'For': mainProductTitle
          } 
        }]
      }),
    })
    .then(response => response.json())
    .then(data => {
      console.log("Added to cart:", data);
      buttonElement.style.display = "none";
      const removeButton = buttonElement.nextElementSibling;
      removeButton.style.display = "flex";
      removeButton.style.opacity = ".9";
    })
    .catch(error => {
      console.log("Error adding to cart:", error);
    });
  }

  function removeVariantSelectedFromCart(variantId, buttonElement) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      }),
    })
    .then(response => response.json())
    .then(data => {
      console.log("Removed from cart:", data);
      buttonElement.style.display = "none";
      const addButton = buttonElement.previousElementSibling;
      addButton.style.display = "flex";
    })
    .catch(error => {
      console.log("Error removing from cart:", error);
    });
  }
}

initializeQuickATCVariantSelected();